import React from 'react';
import './WideCard.css';
import {type Course} from "../../../api/courcesService";
import { useTranslation } from 'react-i18next';

// Utility function to get image URL from Strapi featuredImage format
const getImageUrl = (featuredImage: any): string => {
  if (!featuredImage) {
    return 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=240&fit=crop&crop=center';
  }

  // const baseUrl = SERVER_URL.replace('/api', '');
  const baseUrl = '';

  if (featuredImage.formats?.medium?.url) {
    return baseUrl + featuredImage.formats.medium.url;
  } else if (featuredImage.formats?.small?.url) {
    return baseUrl + featuredImage.formats.small.url;
  } else if (featuredImage.url) {
    return baseUrl + featuredImage.url;
  }

  return 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=240&fit=crop&crop=center';
};

interface WideCardProps {
  course?: Course;
  loading?: boolean;
  onClick?: () => void;
}

const WideCard: React.FC<WideCardProps> = ({ course, loading, onClick }) => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <div className="recommended-wide-card skeleton" aria-hidden>
        <div className="recommended-wide-card-content">
          <div className="recommended-wide-card-text">
            <div className="skeleton-line long" />
            <div className="skeleton-line" />
            <div className="skeleton-line short" />
          </div>
        </div>
      </div>
    );
  }

  if (!course) return null;

  return (
    <div className="recommended-wide-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="recommended-wide-card-content">
        <div className="recommended-wide-card-text">
          <div className="recommended-wide-card-title">{t('product.courses.newLabel', 'New')}: {course.title}</div>
          <div className="recommended-wide-card-desc">{course.description}</div>
        </div>
        <div className="recommended-wide-card-image">
          <img
            src={getImageUrl(course?.featuredImage)}
            alt={course.title}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=240&fit=crop&crop=center';
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WideCard;
